<template>
  <div class="container">

    <el-dialog
            title="第三方标签"
            :visible.sync="dialogVisible"
            center
            width="40%"
            @close="dialogClosed">
        <el-form :model="addform" label-position="right" :rules="addrules" ref="refaddForm" label-width="130px" style="width: 90%;">
            <el-form-item label="加工单号" prop="processingOrderNo">
                <el-input v-model.trim="addform.processingOrderNo" autocomplete="off" maxlength="20" clearable></el-input>
            </el-form-item>
            <el-form-item label="采购单号" prop="purchaseOrderNo">
                <el-input v-model.trim="addform.purchaseOrderNo" autocomplete="off" maxlength="20" clearable></el-input>
            </el-form-item>
            <el-form-item label="物料编号" prop="customPartNo">
                <el-input v-model.trim="addform.customPartNo" autocomplete="off" maxlength="20" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button class="cancelButton" size="small" @click="dialogVisible = false">取消</el-button>
            <el-button
                    type="primary"
                    size="small"
                    @click="saveForm()"
                    :loading="loadingForm">
                保存
            </el-button>
        </span>
    </el-dialog>

    <div class="topContainer">
      <el-form :model="form" style="width: 80%;" ref="refForm" :rules="rules" label-width="180px">
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.deliveryInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.productOrderNo') + ':'" prop="productOrderNo">
              <el-input
                v-model.trim="form.productOrderNo"
                disabled
                name="productOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.orderTime') + ':'" prop="orderDate">
              <el-input
                v-model.trim="form.orderDate"
                disabled
                name="orderDate"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.expectedDeliveryNumber') + ':'" prop="expectCount">
              <el-input
                v-model.trim.number="form.expectCount"
                disabled
                type="tel"
                autocomplete="on"
                clearable
                size="small"
                maxlength="10"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.customerInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.customerName') + ':'" prop="customerId">
              <el-select
                v-model="form.customerId"
                disabled
                clearable
                filterable
                style="width: 100%;"
                size="small"
                @change="changeCustomer">
                <el-option
                  v-for="item in customersList"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.contact') + ':'" prop="contact">
              <el-input
                v-model.trim="form.contact"
                disabled
                name="contact"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="16">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.contactPhone') + ':'" prop="contactPhone">
              <el-input
                v-model.trim="form.contactPhone"
                disabled
                name="contactPhone"
                type="tel"
                autocomplete="on"
                clearable
                size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.address') + ':'" prop="contactAddr">
              <el-input
                v-model.trim="form.contactAddr"
                disabled
                name="incoOrderNo"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="20">
            <el-form-item :label="$t('common.comment') + ':'">
              <el-input
                v-model="form.comment"
                disabled
                name="comment"
                type="textarea"
                autocomplete="on"
                clearable
                size="small"
                maxlength="200"
                show-word-limit
                rows="4">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.expressInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.expressageType')" prop="expressageType">
              <el-select
                v-model="form.expressageType"
                disabled
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key) in expressageTypes"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.expressage')" prop="expressage">
              <el-select
                v-model="form.expressage"
                disabled
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key)  in expressages"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('common.binLevel')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.binLevel')" prop="binLevelArr">
              <el-select
                disabled
                v-model="form.binLevelArr"
                clearable
                filterable
                multiple
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, index) in 8"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.confirmedQuantity')}}</h4>
        </el-form-item>
      </el-form>
      <div class="target-container">
        <el-table
          ref="table"
          border
          :data="prodStores"
          :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
          :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
          header-cell-class-name="headerCellName"
          :span-method="objectSpanMethod">
          <el-table-column prop="incoOrderNo" :label="$t('common.orderNo')">
          </el-table-column>
          <el-table-column prop="subNo" :label="$t('common.subNo')">
          </el-table-column>
          <el-table-column prop="boxNo" :label="$t('common.boxNo')"/>
          <el-table-column prop="binLevel" :label="$t('common.binLevel')"/>
          <el-table-column :label="$t('common.productName')" width="200">
            <template slot-scope="scope">
              {{productName(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column prop="lotNo" :label="$t('common.lotNo')"/>
          <el-table-column :label="$t('common.processType')">
            <template slot-scope="scope">
              {{processTypeVal(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column prop="allCount" :label="$t('common.count')"/>
          <el-table-column :label="$t('common.passCount')">
            <template slot-scope="scope">
              {{scope.row.binLevel !== 8 ? scope.row.count : 0}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.failCount')">
            <template slot-scope="scope">
              {{scope.row.binLevel === 8 ? scope.row.count : 0}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="control-container">
      <div>
        <el-button @click="prevStep" size="small" class="prev-button">
          {{$t('common.prevStep')}}
        </el-button>
        <el-button @click="exportXlsx" size="small" type="primary">
          {{$t('deliveryGoods.saveXLSX')}}
        </el-button>
<!--        <el-button @click="factoryLabel" size="small" type="primary">
          三方标签
        </el-button> -->
        <el-button @click="submitForm" size="small" class="sure-button">
          {{$t('deliveryGoods.saveAndPrint')}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { prodOrderDetailById } from '@/api/prodOrder';
import { customersList } from '@/api/customers';
import { consignorsList } from '@/api/consignors';
import {
  validateContactPhone,
} from '@/utils/validate';
import {
  priorityLevels, processTypes, storeStatus, expressages, expressageTypes,labelTypes,
} from '@/utils/defines';
import exportInvoiceXlsx from '@/utils/exportInvoice';
import {
  productsDetailById,
  caseDetailByProductOrderNo,
} from '@/api/prodStorage';
import {
  boxLabelTypes,
} from '@/utils/defines';

const defaultForm = {
  productOrderNo: undefined,
  orderDate: undefined,
  customerId: undefined,
  contact: undefined,
  contactPhone: undefined,
  contactAddr: undefined,
  comment: undefined,
  expressageType: undefined,
  expressage: undefined,
  priorityLevel: undefined,
  expectCount: undefined,
  binLevelArr: undefined,
};

const adddefaultForm = {
  processingOrderNo: undefined,
  purchaseOrderNo: undefined,
  customPartNo: undefined,
};

const FAIL_BIN = 8;

export default {
  name: 'check-info',
  props: [
    'productOrder',
  ],
  data() {
    const processTypesObj = {};
    let processTypeItem;
    for (const key in processTypes) {
      if (Object.prototype.hasOwnProperty.call(processTypes, key)) {
        processTypeItem = processTypes[key];
        processTypesObj[processTypeItem.val] = processTypeItem.explain;
      }
    }
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.prodOderExplain || storeStatueItem.explain;
      }
    }
    return {
      form: Object.assign({}, defaultForm),
      addform: Object.assign({}, adddefaultForm),
      rules: {
        productOrderNo: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.productOrderNoCanNotBeEmpty') }],
        orderDate: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.orderTimeCanNotBeEmpty') }],
        expectCount: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expectedDeliveryNumberCanNotBeEmpty') }],
        customerId: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.customerNameCanNotBeEmpty') }],
        contact: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone }],
        contactAddr: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        expressageType: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageTypeCanNotBeEmpty') }],
        expressage: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageCanNotBeEmpty') }],
        binLevelArr: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.binLevelArrCanNotBeEmpty') }],
      },
      addrules: {
        processingOrderNo: [{ required: true, trigger: 'blur', message: '加工单号不能为空'}],
        purchaseOrderNo: [{ required: true, trigger: 'blur', message: '采购单号不能为空'}],
        customPartNo: [{ required: true, trigger: 'blur', message: '物料编号不能为空'}],
      },
      customersList: [],
      processTypesObj,
      storeStatusObj,
      expressages,
      expressageTypes,
      labelTypes,
      prodStores: [],
      detail: {},
      detailProdStores: [],
      dialogVisible: false,
      loadingForm: false,
      incoOrderProdStoreParsed: [],
      labelType: 0,
    };
  },
  mounted() {
    this.customersListGet(1, 200);
    this.prodOrderDetailById();
  },
  methods: {
    prevStep() {
      this.$emit('prevStep');
    },
    exportProdStores() {
      const detailProdStores = this.detailProdStores;
      let prodStores = [];
      let length, info, count, badChipInfoCount, directrix = 0, prodStoresItemArray;
      for (const row of detailProdStores) {
        info = row.info;
        count = row.count;
        length = info.length;
        badChipInfoCount = 0;
        prodStoresItemArray = [];
        for (let i = 0; i < length; i++) {
          if (row.binLevel === FAIL_BIN) {
            for (let [key, val] of Object.entries(info[i].badChipInfo)) {
              if (badChipInfoCount === 0) {
                prodStoresItemArray.push({
                  ...row,
                  ...info[i],
                  binLevelVal: key,
                  count: val,
                  rowspan: Object.keys(info[i].badChipInfo).length,
                  allCount: count,
                });
              } else {
                prodStoresItemArray.push({
                  ...row,
                  ...info[i],
                  binLevelVal: key,
                  count: val,
                  rowspan: length,
                  allCount: count,
                });
              }
              badChipInfoCount++;
            }
          } else {
            if (i === 0) {
              prodStoresItemArray.push({
                ...row,
                ...info[i],
                binLevelVal: 'A',
                rowspan: length,
                allCount: count,
              });
            } else {
              prodStoresItemArray.push({
                ...row,
                ...info[i],
                binLevelVal: 'A',
                rowspan: length,
                allCount: count,
              });
            }
          }
        }
        prodStoresItemArray.sort((a, b) => b.count - a.count);
        for (let i = 1, arrayLength = prodStoresItemArray.length; i < arrayLength; i++) {
          prodStoresItemArray[i].rowspan = undefined;
        }
        prodStores = prodStores.concat(prodStoresItemArray);
        if (row.binLevel === FAIL_BIN) {
          prodStores[directrix].rowspan = badChipInfoCount === 1 ? undefined : badChipInfoCount;
          directrix = badChipInfoCount;
        } else {
          directrix = length;
        }
      }
      return prodStores;
    },
    factoryLabel() {
      this.dialogVisible = true;
    },
    saveForm(){
      this.$refs.refaddForm.validate(async (valid) => {
        if (valid) {
          this.loadingForm = true;
          this.getLabel();
        }
      });
    },
    async getLabel() {
      const {
        productOrderNo,
      } = this.productOrder;
      const {
        processingOrderNo,
        purchaseOrderNo,
        customPartNo,
      } = this.addform;
      const tempPage = window.open('', '_blank');
      try {

        const res = await caseDetailByProductOrderNo({ productOrderNo });
        let blabels = [];
        let list = res.data;
        let dateCode = moment().format('YYYY-MM-DD');
        let boxlabel;
        let hasBoxLabel = false;
        for(let type of this.labelTypes){
          if(type.val === this.labelType){
            hasBoxLabel = type.hasBoxLabel;
            break;
          }
        }
        for(let temp of list) {
          boxlabel = {};
          boxlabel.labelType = this.labelType;
          boxlabel.boxLabelType = boxLabelTypes.boxLabel.val;
          boxlabel.processingOrderNo = processingOrderNo;
          boxlabel.purchaseOrderNo = purchaseOrderNo;
          boxlabel.customPartNo = customPartNo;
          boxlabel.qty = temp.qty;
          boxlabel.dateCode = dateCode;
          boxlabel.partNo = temp.partNo;
          boxlabel.lotNo = temp.lotNo;
          boxlabel.marking = temp.marking;
          boxlabel.netWeight = temp.netWeight;
          boxlabel.packageType = temp.packageType;
          boxlabel.productName = temp.labels[0].product.productName;
          boxlabel.chipName = temp.labels[0].product.chipName;
          boxlabel.binLevel = temp.binLevel;
          boxlabel.trackingNo = temp.trackingNo;
          boxlabel.grossWeight =  temp.grossWeight;
          boxlabel.reserve = temp.reserve;
          let detail = [];
          if(hasBoxLabel){
            let d;
            for(let prodStoreDetails of temp.labels) {
              d = {};
              d.qty = prodStoreDetails.qty;
              d.trackingNo = prodStoreDetails.trackingNo;
              detail.push(d);
            }
          }
          boxlabel.detail = detail;
          blabels.push(boxlabel);
        }
        const { href } = this.$router.resolve({
          path: `/factory-label-print`,
          query: {
            data: encodeURIComponent(JSON.stringify(blabels))
          },
        });
        tempPage.location = href;
      } catch (e) {
        // do nothing.
      } finally {
        this.loadingForm = false;
        this.dialogVisible = false;
      }
    },
    dialogClosed () {
        this.$refs.refaddForm && this.$refs.refaddForm.resetFields();
    },
    async exportXlsx() {
      const productOrderNo = this.form.productOrderNo;
      const prodStores = this.exportProdStores();
      try {
        const resConsignors = await consignorsList({
          perpage: 10,
          page: 1,
        });
        const consignorsData = resConsignors.data;
        let consignor = {};
        if (consignorsData && consignorsData.records && consignorsData.records.length > 0) {
          consignor = consignorsData.records[0];
        }
        const {
          contactAddr,
          expressage,
        } = this.form;
        const expressages = this.expressages;
        exportInvoiceXlsx({
          consignor,
          prodStores,
          productOrderNo,
          contactAddr,
          expressage: expressages[expressage].explain,
        });
      } catch (e) {
        // do nothing.
      }
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.onSave();
        }
      });
    },
    async onSave() {
      const {
        prodStores
      } = this;
      const {
        expectCount
      } = this.form;
      if (!prodStores || prodStores && prodStores.length === 0) {
        this.$message({
          type: 'error',
          message: '请先去手持设备上关联箱子',
        });
        return;
      }
      let count = 0;
      for (let row of prodStores) {
        count += row.count;
      }
      if (count < expectCount) {
        this.$confirm(this.$t('deliveryGoods.chipCountLessThanExpectCount'), this.$t('remindInfo.warning'), {
          confirmButtonText: this.$t('remindInfo.confirm'),
          cancelButtonText: this.$t('remindInfo.cancel'),
          type: 'warning',
        }).then(async () => {
          this.toInvoice();
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.toInvoice();
      }
    },
    toInvoice() {
      const {
        productOrderNo,
      } = this.productOrder;
      const { href } = this.$router.resolve({
        path: `/invoice/${productOrderNo}`,
        query: {},
      });
      window.open(href, '_blank');
    },
    changeCustomer(val) {
      const {
        contact,
        contactPhone,
        contactAddr,
      } = this.form;
      if (val) {
        for (const row of this.customersList) {
          if (row.id === val) {
            this.form.contact = row.contact;
            this.form.contactPhone = row.contactPhone;
            this.form.contactAddr = row.contactAddr;
            this.$refs.refForm.validateField(['customerId', 'contact', 'contactPhone', 'contactAddr']);
            break;
          }
        }
      }
    },
    async customersListGet(page, perpage, customerName) {
      try {
        const res = await customersList({ page, perpage, customerName });
        const { data } = res;
        this.customersList = data.records;
      } catch (e) {
        // do nothing.
      }
    },
    async prodOrderDetailById() {
      const {
        productOrderNo,
      } = this.productOrder;
      try {
        const res = await prodOrderDetailById({ productOrderNo });
        const {
          data,
        } = res;
        if (data) {
          const {
            productOrderNo,
            createAt,
            customerId,
            contact,
            contactPhone,
            contactAddr,
            comment,
            expressageType,
            expressage,
            priorityLevel,
            prodStores,
            expectCount,
            binLevelData,
          } = data.detail;
          this.detailProdStores = prodStores;
          this.labelType = data.detail.customer.labelType;
          this.incoOrderProdStoreParsed = data.incoOrderProdStoreParsed;
          this.form = {
            productOrderNo,
            orderDate: this.formatDate(createAt),
            customerId,
            contact,
            contactPhone,
            contactAddr,
            comment,
            expressageType,
            expressage,
            priorityLevel,
            expectCount,
            binLevelArr: binLevelData,
          };
          this.prodStores = [];
          let length, info, count, index = 0;
          for (let row of prodStores) {
            info = row.info;
            count = row.count;
            length = info.length;
            index++;
            for(let i = 0; i < length; i++) {
              if (i === 0) {
                this.prodStores.push({
                  ...row,
                  ...info[i],
                  rowspan: length,
                  allCount: count,
                  index,
                });
              } else {
                this.prodStores.push({
                  ...row,
                  ...info[i],
                  allCount: count,
                });
              }
            }
          }
        }
      } catch (e) {
        // do nothing.
      }
    },
    processTypeVal(row) {
      const {
        processType
      } = row;
      return this.processTypesObj[processType];
    },
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    productName(row) {
      const {
        productName,
        chipName,
      } = row;
      if (!productName || !chipName) {
        return '';
      }
      return `${productName} / ${chipName}`;
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD HH:mm:ss');
      }
      return updateDate.local().format('YYYY/MM/DD HH:mm:ss');
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2 || columnIndex === 3 || columnIndex === 7) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .topContainer {
    height: 100%;
    overflow: auto;
    flex: 1;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .control-container {
    background: #F5F5F5;
    padding: 20px;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .target-container {
    margin: 20px 20px 0;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .prev-button {
    background: white;
    color: #EC7900;
    border: #EC7900 solid 1px;
  }
  .sure-button {
    background: #EC7900;
    color: white;
  }
  .el-form {
    padding: 10px 20px 0;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
